import { Link } from "react-router-dom";

const pages = {
  privacy: {
    title: "Privacy Policy",
    updated: "April 2026",
    sections: [
      {
        body: "iambecause is a place for real stories. We take what you share seriously — and we treat your information with the same care we ask you to bring to your story."
      },
      {
        heading: "What we collect",
        body: "When you submit a story, we collect your name, what you do, your why, your city, and optionally your photo, video, or voice note and your email address."
      },
      {
        heading: "What we do with it",
        body: "Your story — your name, role, why, location, and media — is published on iambecause.com if approved. Your email address is never published, never sold, never shared with anyone. We use it only to let you know when your story goes live."
      },
      {
        heading: "Who sees your story",
        body: "Once approved, your story is public. Anyone can read it, share it, or embed it. If you ever want your story removed, email us at hello@iambecause.com and we will take it down within 48 hours. No questions asked."
      },
      {
        heading: "Cookies",
        body: "We use no advertising cookies. We may use basic analytics to understand how many people are reading stories."
      },
      {
        heading: "Contact",
        body: "hello@iambecause.com"
      }
    ]
  },
  terms: {
    title: "Terms of Use",
    updated: "April 2026",
    sections: [
      {
        body: "Welcome to iambecause. By submitting a story or using this site you agree to these simple terms."
      },
      {
        heading: "Your story is yours",
        body: "You own what you write. By submitting it to iambecause you give us permission to publish it on this site and share it on our social media. We will never sell your story or use it commercially."
      },
      {
        heading: "Be honest",
        body: "Submit only your own story. Don\u2019t impersonate anyone. Don\u2019t submit content that belongs to someone else."
      },
      {
        heading: "Be kind",
        body: "iambecause is a place of genuine human stories. We do not publish content that is abusive, hateful, discriminatory, or harmful to any person or group. We review every submission before it goes live and reserve the right to decline any story without explanation."
      },
      {
        heading: "Taking your story down",
        body: "You can ask us to remove your story at any time by writing to hello@iambecause.com. We will remove it within 48 hours."
      },
      {
        heading: "Our right to moderate",
        body: "We reserve the right to remove any story at any time if it violates the spirit of iambecause \u2014 which is honesty, kindness, and genuine human experience."
      }
    ]
  },
  guidelines: {
    title: "Content Guidelines",
    updated: "April 2026",
    sections: [
      {
        heading: "What iambecause is \u2014 and isn\u2019t",
        body: "iambecause exists for one reason. To ask people why they do what they do. And to give their answer a permanent, beautiful home."
      },
      {
        heading: "What belongs here",
        body: "Your real story. In your own words. The moment, the person, the circumstance that brought you to exactly where you are. It can be long or short. Polished or raw. Joyful or painful. As long as it is true."
      },
      {
        heading: "What doesn\u2019t belong here",
        body: "We don\u2019t publish promotional content, advertisements, or stories written to sell something. We don\u2019t publish content that harms, humiliates, or targets any individual or group. We don\u2019t publish fiction presented as fact."
      },
      {
        heading: "No editing \u2014 but we do review",
        body: "We never change your words. What you write is what gets published. But we read every submission before it goes live \u2014 not to judge, but to ensure the spirit of this place stays honest and kind."
      },
      {
        heading: "One story per person",
        body: "iambecause is about breadth \u2014 as many different whys as possible. Please submit one story. If your why changes profoundly, write to us."
      },
      {
        heading: "Questions",
        body: "hello@iambecause.com"
      }
    ]
  }
};

export default function LegalPage({ page }) {
  const content = pages[page];
  if (!content) return null;

  return (
    <div data-testid={`${page}-page`} className="min-h-screen bg-white">
      <div className="bg-[#FBF7F0] py-16 md:py-20">
        <div className="max-w-2xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.25em] font-sans font-semibold text-[#E91E8C] mb-4">
            Last updated: {content.updated}
          </p>
          <h1 className="text-3xl sm:text-4xl font-medium tracking-tight text-[#16130F]">
            {content.title}
          </h1>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="space-y-8">
          {content.sections.map((section, i) => (
            <div key={i}>
              {section.heading && (
                <h2 className="text-lg font-semibold text-[#16130F] mb-2">
                  {section.heading}
                </h2>
              )}
              <p className="font-sans text-lg leading-relaxed text-[#4B5563]">
                {section.body}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-[#E5E7EB]">
          <Link to="/" className="text-sm font-sans text-[#E91E8C] hover:underline">
            &larr; Back to stories
          </Link>
        </div>
      </div>
    </div>
  );
}
